import { v4 as uuid } from "uuid";

const articleData = [
  {
    _id: uuid(),
    src: "https://i.pravatar.cc/300",
    alt: "A random avatar",
    title: "Tony",
    profession: "Author",
    description: "Lorem ipsum...",
  },
  {
    _id: uuid(),
    src: "https://i.pravatar.cc/300",
    alt: "A random avatar",
    title: "Tony",
    profession: "Author",
    description: "Lorem ipsum...",
  },
];

export { articleData };
